import styled from 'styled-components';

import Skeleton from '@/components/atom/skeleton';

const EmptyTabsSkeleton = () => {
  return (
    <Wrapper>
      <Skeleton style={{ width: 50, height: 22 }} />
      <Skeleton style={{ width: 50, height: 22 }} />
      <Skeleton style={{ width: 80, height: 22 }} />
      <Skeleton style={{ width: 70, height: 22 }} />
      <Skeleton style={{ width: 80, height: 22 }} />
    </Wrapper>
  );
};

export default EmptyTabsSkeleton;

const Wrapper = styled.div`
  display: flex;
  height: 46px;
  padding: 12px 0;
  padding-left: 24px;
  display: flex;
  flex-direction: row;
  gap: 12px;

  ${({ theme }) => `
    border-bottom: 1px solid ${theme.color.gray100};
  `};
`;
